const getIconsColors = () => {
  return {
    twoToneStrokeColor: {
      default: 'primary.800',
      _dark: 'primary.600',
    },
    twoToneFillColor: {
      default: 'primary.500',
      _dark: 'primary.300',
    },
    twoToneLightColor: {
      default: 'primary.300',
      _dark: 'primary.900',
    },
  }
}

export default getIconsColors()
